/* СПРАВОЧНИКИ (ЗАГРУЗКА ИЗ БАЗЫ) */

const ROOT_API = process.env.VUE_APP_ROOT_API;

const catalogs = ROOT_API + 'get_catalogs/';

const catalogs_path_default = catalogs;

const catalogs_path = {
	info_state_cat: catalogs + 'get_state_cat.php',
	info_mzl_agit: catalogs + 'get_mzl_agit.php',
	info_mzl_prof: catalogs + 'get_mzl_prof.php',
	info_mzl_neighbor: catalogs + 'get_mzl_neighbor.php',
	info_species: catalogs + 'get_species_all.php'
};

export default {
	state: {
		info_ozu: [],
		info_oopt: [],
		info_age_groups: [],
		info_tlu: [],
		info_protection_category: [],
		info_forest_purpose: [],

		info_disparity_reasons: [],
		info_bonitet: [],

		info_species: [],

		info_state_cat: [],

		info_forest_zone: [],
		info_non_forest_land: [],
		info_unforested_land: [],

		info_land_categories: [],
		info_forest_use: [],
		info_lease_types: [],
		info_lease_contract_types: [],

		info_pest_core_type: [],
		info_pest_core_phase: [],
		info_pests: [],

		info_inspection_type: [],
		info_nonliquid_reasons: [],
		info_critical_density: [],

		info_mzl_agit: [],
		info_mzl_prof: [],
		info_mzl_neighbor: [],
		info_mzl: [],
		info_pollution: [],
		info_wreck_reasons: [],

		info_filials: [],
		info_users_post: [],
		info_user_roles: [],

		info_radioactive_zone: [],
		info_bnt: [],

		info_slope_angle: [], /* угол наклона для реласкопов */
		info_damage_reason_groups: [],
		info_remote_condition: [],
		info_remote_image_mode: [],
		info_remote_aircraft_type: [],
		info_distribution_types: []
	},

	mutations: {
		setCatalog(state, payload) {
			const catalog_name = payload['catalog_name'];
			const catalog_data = payload['catalog_data'];

			state[catalog_name] = catalog_data;
		},

		addEmptyValueForCatalog(state, catalog_name) {
			state[catalog_name].unshift({ id: null, name: '( нет ) ', isEmpty: true });
		}
	},

	actions: {
		getCatalog(context, payload) {
			const { rootState, commit } = context;

			const catalog_name = payload;
			const catalog_path = catalogs_path[catalog_name] || catalogs_path_default;

			const form = new FormData();
			form.append('catalog_name', catalog_name);

			if (catalog_name === 'info_mzl_prof') {
				form.append('lpo_id', rootState.selectedLpo.lpo.lpo_id);
			}

			return fetch(catalog_path, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				const payload = {
					catalog_name: catalog_name,
					catalog_data: res
				};
				commit('setCatalog', payload);
			})
			.catch(err => console.log(err));
		},

		async loadCatalogs(context, payload) {
			const { dispatch } = context;

			const catalogs = payload;

			for (let catalog of catalogs) {
				await dispatch('getCatalog', catalog);
			}
		}
	}
};